import type { FC } from 'react'

import type { ReactLinkButtonProps } from '@/types/components/link-button'

import { Link } from './Link'

export const LinkButton: FC<ReactLinkButtonProps> = ({
  link,
  className = '',
  onClick,
}) => {
  const { type, text } = link

  const classes = [
    ...(type !== 'underlined' ? ['button', `button--${type}`] : ['link']),
    className,
  ]

  return (
    <Link link={link} classes={classes} onClick={onClick}>
      {text}
    </Link>
  )
}
